"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventLoopSpinner = void 0;
const event_loop_spinner_1 = require("./event-loop-spinner");
exports.eventLoopSpinner = new event_loop_spinner_1.EventLoopSpinner();
//# sourceMappingURL=index.js.map